var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3333 1.66406V4.9974M5.66667 1.66406V4.9974M1.5 8.33073H16.5M3.16667 3.33073H14.8333C15.7538 3.33073 16.5 4.07692 16.5 4.9974V16.6641C16.5 17.5845 15.7538 18.3307 14.8333 18.3307H3.16667C2.24619 18.3307 1.5 17.5845 1.5 16.6641V4.9974C1.5 4.07692 2.24619 3.33073 3.16667 3.33073Z",
    stroke: "#AAAAAA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5d5a241ff5155bdf36feb47fb1bfdb1f.svg";
export { ForwardRef as ReactComponent };